import React from 'react';
import { cn } from '@/lib/utils';
import { LucideIcon } from 'lucide-react';
import { IconTitle } from '@/components/ui/icon-title';

interface CardProps {
  title: string;
  icon: LucideIcon | React.ComponentType<{ className?: string }>;
  children: React.ReactNode;
  className?: string;
  iconClassName?: string;
}

export function Card({ title, icon, children, className, iconClassName }: CardProps) {
  return (
    <div className={cn(
      "flex flex-col gap-[6px] p-2 bg-white rounded-[10px] shadow-card border border-light-grey",
      className
    )}>
      <IconTitle icon={icon} title={title} iconClassName={iconClassName} />
      {children}
    </div>
  );
}